<template>
  <label class="block">
    <span class="cursor-pointer text-sm my-1">{{ label }}</span>
    <input :value="value" :type="type" @input="input" :id="id" :placeholder="placeholder" :maxlength="maxlength"
           :minlength="minlength"
           :class="[error ? inputError : inputValid]"
           :disabled="disabled"
           :min="min"
           :max="max"
           class="w-full outline-none w-full px-3 py-2 px-2 bg-white border border-gray-300 focus:shadow-outline" />
     <span v-if="info && !error" class="w-full text-sm text-blue-800 mt-1 mb-0">{{ info }}</span>
     <span v-if="error" class="w-full text-sm text-red-800 mt-1 mb-0">{{ error }}</span>
  </label>
</template>

<script>
  export default {
    name: "Input",
    props: {
      value: {
        required: true
      },
      id: {
        required: true
      },
      errors: {
        default: null
      },
      placeholder: {
        default: null
      },
      type: {
        default: 'text'
      },
      label: {
        default: null
      },
      info: {
        default: null
      },
      maxlength: {
        default: null
      },
      minlength: {
        default: null
      },
      disabled: {
        default: false
      },
      min: {
        default: 0
      },
      max: {
        default: null
      }
    },
    data() {
      return {
        labelValid: 'text-green-800',
        labelError: 'text-red-800',
        inputValid: 'border-gray-500 hover:border-green-700 focus:border-green-900',
        inputError: 'border-red-500 hover:border-red-700 focus:border-red-900'
      }
    },
    computed: {
      error() {
        if(!this.errors) return false
        return this.errors.has(this.id) ? this.errors.first(this.id) : false
      }
    },
    methods: {
      input(e) {
        if(this.errors) this.errors.clear(this.id);
        this.$emit('input', e.target.value)
      }
    }
  }
</script>

<style scoped lang="scss">
  input[disabled] {
    @apply cursor-not-allowed opacity-50;
  }
</style>
